const CheckboxValues = {
    ON: '1',
    OFF: '',
};

export { CheckboxValues };